import React from 'react';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import Layout from "./Layout";

const Root = (props: Props) => {
    document.title = props.t("description.title") + " - " + props.t("zavediaev")

    return (
        <Translation>{t =>
            <div>
                <Layout>
                    <div>
                        <h2>Error</h2>
                        <p>Unexpected Error occurred</p>
                    </div>
                </Layout>
            </div>
        }</Translation>
    )
}

interface Props extends WithTranslation {
}

export default withTranslation()(Root)
